import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { ActiveCampaign } from "@/model/interface/DashboardSummary";

const CampaignsCard: React.FC<{ campaigns: ActiveCampaign[] }> = ({ campaigns }) => {
  const navigate = useNavigate();

  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Campaigns</h2>
        <Button variant="link" size="sm" className="h-auto px-0 text-xs" onClick={() => navigate("/campaigns")}>
          View all
        </Button>
      </div>
      {campaigns.length === 0 ? (
        <p className="py-2 text-sm text-muted-foreground">No active campaigns.</p>
      ) : (
        <div className="flex flex-col gap-1">
          {campaigns.map((campaign) => (
            <div key={campaign.id ?? campaign.name} className="flex items-center gap-2.5 rounded-md px-1 py-2">
              <span
                className={cn(
                  "h-2 w-2 shrink-0 rounded-full",
                  campaign.status === "ACTIVE" ? "animate-pulse bg-success" : "bg-warning",
                )}
              />
              <div className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium">{campaign.name ?? "Untitled campaign"}</span>
                <p className="truncate text-xs text-muted-foreground tabular-nums">
                  {campaign.contactsRemaining} contacts remaining
                </p>
              </div>
              <Button
                variant="outline"
                size="sm"
                className="h-7 shrink-0"
                onClick={() => campaign.id && navigate(`/power-dialer/${campaign.id}`)}
              >
                Resume
              </Button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default CampaignsCard;
